import router from '@/router'
import axios from 'axios'

const state = {
  user: {
    name: null,
    email: null,
    api_token: null
  }
}

// Getters
const getters = {
  // UserData
  user (state) {
    return (state.user && state.user.name) ? state.user.name : false
  },
  userEmail (state) {
    return (state.user && state.user.email) ? state.user.email : false
  },
  isSuperAdmin (state) {
    const superadminEmails = ['lais@heppi.me', 'davi@heppi.me', 'guilherme.mourao@heppi.com.br']
    return !!(state.user && state.user.email && superadminEmails.includes(state.user.email))
  },
  isBackoffice (state) {
    const backofficeEmails = ['lais@heppi.me', 'beatrizmelo@heppi.me', 'guilherme.mourao@heppi.com.br']
    return !!(state.user && state.user.email && backofficeEmails.includes(state.user.email))
  },
  isYoung (state) {
    const youngEmails = ['rafaeltorresbraz@gmail.com']
    return !!(state.user && state.user.email && youngEmails.includes(state.user.email))
  },
  api_token (state) {
    return state.user.api_token
  }
}

// Mutations
const mutations = {
  'SET_USER' (state, userInfo) {
    let info = null
    if (userInfo) {
      info = userInfo
    } else if (localStorage.getItem('userInfo')) {
      info = JSON.parse(localStorage.getItem('userInfo'))
    }

    state.user.name = info.name || null
    state.user.email = info.email || null
    state.user.api_token = info.api_token || null

    if (userInfo !== false) {
      localStorage.setItem('userInfo', JSON.stringify(state.user))
    } else {
      localStorage.removeItem('userInfo')
    }
  }
}

// Actions
const actions = {
  isLogged ({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      // Set token
      let token = state.user.api_token || JSON.parse(localStorage.getItem('userInfo')).api_token
      if (token) {
        if (!state.user.api_token) commit('SET_USER')
        resolve()
      } else {
        dispatch('logout')
        reject(new Error('Sessão Expirada'))
      }
    })
  },
  logout ({ commit, state }) {
    let token = state.user.api_token
    axios.get('logout?api_token=' + token)
    commit('SET_USER', false)
    router.push({ name: 'login' })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
